import { render, staticRenderFns } from "./DocxTemplateUsageDialog.vue?vue&type=template&id=2799a6d0&scoped=true"
import script from "./DocxTemplateUsageDialog.vue?vue&type=script&lang=js"
export * from "./DocxTemplateUsageDialog.vue?vue&type=script&lang=js"
import style0 from "./DocxTemplateUsageDialog.vue?vue&type=style&index=0&id=2799a6d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2799a6d0",
  null
  
)

export default component.exports